import { useModalContext } from 'utils/contexts/modal';
import { MODAL_ACTION } from 'modules/jobManager/constants';
import { ModelContextState } from 'modules/jobManager/types';
import { CreateJobModal } from './CreateJobModal';
import { CancelJobModal } from './CancelJobModal';

export const Modals = () => {
  const { modalState } = useModalContext<ModelContextState>();

  if (!modalState) return null;

  const renderModal = () => {
    switch (true) {
      case modalState.action === MODAL_ACTION.CREATE_JOB:
        return <CreateJobModal />;

      case modalState.action === MODAL_ACTION.CANCEL_JOB:
        return <CancelJobModal />;

      default:
        return null;
    }
  };

  return <>{renderModal()}</>;
};
